import styled from "styled-components";
import Theme from "../../styles/Theme";

export const CuratorWrapper = styled.section`
  background: ${Theme.color.mainBlack};
`;

export const CuratorFeedLayout = styled.div`
  a {
    color: ${Theme.color.mainWhite};
  }
`;
